import { Button, Card, CardHeader, Divider, Skeleton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { AgendaItemResource } from "./AgendaItemResource";
import { CreateAgendaItemResourceModal } from ".";
import { useGetAgendaItemResources } from "../../../http";

interface IProps {
  agendaStepGuid: string;
  agendaStepName: string;
}

const ResourcesAgendaStep = (props: IProps) => {
  const { data, isLoading } = useGetAgendaItemResources(props.agendaStepGuid);
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Card>
        <CardHeader title={<Typography variant="h6">{props.agendaStepName}</Typography>} />
        <Divider />
        <Stack spacing={1} sx={{ p: 1 }}>
          {isLoading && (
            <Stack spacing={0.5} sx={{ p: 1 }}>
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} />
              ))}
            </Stack>
          )}
          {!isLoading &&
            data &&
            (data.resources.length === 0 ? (
              <Typography variant="placeholder">No embedded content available for this agenda step.</Typography>
            ) : (
              <Stack spacing={1}>
                {data.resources
                  .sort((a, b) => a.sortOrder.localeCompare(b.sortOrder))
                  .map((resource) => (
                    <AgendaItemResource
                      key={resource.guid}
                      agendaStepGuid={props.agendaStepGuid}
                      resource={resource}
                      resources={data.resources}
                    />
                  ))}
              </Stack>
            ))}
          <Button
            variant="outlined"
            disabled={isLoading}
            onClick={() => setIsModalVisible(true)}
            sx={{ alignSelf: "start" }}
          >
            Add Resource
          </Button>
        </Stack>
      </Card>
      <CreateAgendaItemResourceModal
        agendaStepGuid={props.agendaStepGuid}
        resources={data?.resources ?? []}
        visible={isModalVisible}
        onAdded={() => setIsModalVisible(false)}
        onCancelled={() => setIsModalVisible(false)}
      />
    </>
  );
};

export { ResourcesAgendaStep };
